import { render, staticRenderFns } from "./radios.html?vue&type=template&id=f95126d2&scoped=true&"
import script from "./radios.js?vue&type=script&lang=js&"
export * from "./radios.js?vue&type=script&lang=js&"
import style0 from "./radios.scss?vue&type=style&index=0&id=f95126d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95126d2",
  null
  
)

export default component.exports